// export const environment = {
//   production: false,
//   baseURI: 'https://api.oztap.com.au/restaurantapi/',
//   encryptionKey: '258ac4e4146a411e9dc879a9e12fd6da',
//   b2cURL: 'https://venue.oztap.com.au/',
// };


export const environment = {
  production: true,
  baseURI: 'https://api.oztap.com.au/restaurantapi/',
  encryptionKey: '258ac4e4146a411e9dc879a9e12fd6da',
  b2cURL: 'https://venue.oztap.com.au/',
};
// Local
// http://192.168.100.23:8080/
// http://13.54.106.200:8080/
// Production
// https://api.oztap.com.au/restaurantapi/

// http://3.104.227.253:8080/restaurant-0.0.1-SNAPSHOT/


// Stagging
// 13.54.106.200

// export const environment = {
//   production: true,
//   baseURI: 'http://103.7.64.58/Restaurant/',
//   encryptionKey: '258ac4e4146a411e9dc879a9e12fd6da',
//   b2cURL: 'https://venue.oztap.com.au/',
// };
//newserver path
//https://api.oztap.com.au/restaurantapi/


//https://oztap.com.au/restaurantapi/

//server path baseURI: 'https://www.oz-tap.com.au/restaurantapi/',
//local path baseURI: 'http://localhost:8080/',
